import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Contact from '../components/Contact/Contact'

const Contactus = () => {
  return (
    <>
        <Navbar />
        <Contact />
    </>
  )
}

export default Contactus